import { ApplicationResultCode } from 'next-common';

export const applicationStati = [
  {
    key: ApplicationResultCode.NEW_CASE,
    color: 'var(--color-oldSilver)',
    label: 'Behandles',
    info: 'Forventet behandlingstid: 2-15 minutter',
  },
  {
    key: ApplicationResultCode.DOCUMENTS_APPROVED,
    color: 'var(--color-oldSilver)',
    label: 'Behandles',
    info: 'Forventet behandlingstid: 2-15 minutter',
  },
  {
    key: ApplicationResultCode.DOCUMENTS_GENERATED,
    color: 'var(--color-oldSilver)',
    label: 'Behandles',
    info: 'Forventet behandlingstid: 2-15 minutter',
  },
  {
    key: ApplicationResultCode.CONTROL,
    color: 'var(--color-neutral-soft)',
    label: 'Sendt til manuell behandling',
    info: 'Forventet behandlingstid: 1-2 virkedager',
  },
  {
    key: ApplicationResultCode.REJECTED,
    color: 'var(--color-alertRed)',
    label: 'Avslått',
    info: 'Søk på nytt med annet finansforlag',
  },
  {
    key: ApplicationResultCode.DISBURSED,
    color: 'var(--color-markTurquoise)',
    label: 'Nedbetalt',
    info: '',
  },
  {
    key: ApplicationResultCode.CANCELLED,
    color: 'var(--color-oldSilver)',
    label: 'Kansellert',
    info: '',
  },
  { key: ApplicationResultCode.APPROVED, color: 'var(--color-markTurquoise)', label: 'Godkjent', info: '' },
];

export const statusCodes = Object.keys(ApplicationResultCode).map((x) => ApplicationResultCode[x]);
